import { getAssets } from "@unisearch/helpers";
import Link from "next/link";
import { MdOutlineVerified } from "react-icons/md";
import styles from "./mentor_card.module.scss";

const MentorCard = (props) => {
  return (
    <div
      className={`${styles.mentor_list_item} ${
        props.border ? styles.border : ""
      }`}
    >
      {props.iconVerified && (
        <MdOutlineVerified className={styles.veried_icon} />
      )}

      <div className={styles.mentor_avatar}>
        <Link legacyBehavior href={props.link || "#"}>
          <a>
            <img
              src={props.avatar || getAssets("assets/images/avatar.png")}
              alt="avatar"
            />
          </a>
        </Link>
      </div>

      <Link legacyBehavior href={props.link || "#"}>
        <a>
          <h5 className={styles.mentor_name}>{props?.name || "Name"}</h5>
        </a>
      </Link>
      <p className={styles.mentor_country}>{props?.country}</p>
      <h4 className={styles.mentor_university}>{props?.university}</h4>
      <div className={styles.mentor_designation}>{props.designation}</div>
      <Link legacyBehavior href={props.link}>
        <a className={`btn btn-secondary ${styles.mentor_btn}`}>View Profile</a>
      </Link>
    </div>
  );
};

export default MentorCard;
